const team = {
  header: {
    title: "Team & Workspace Access",
    description: "Every member has an isolated curation and publishing workspace with their own Sources, Filters, AI Configuration, monitored posts, Content Inbox, review state, publishing history, Telegram bot credential, and Destinations. Team and System Settings remain Super-Admin controls.",
    currentAdministrator: "Current system administrator",
    superAdminFallback: "Super-Admin",
  },
  isolation: {
    inboxTitle: "Private Content Inbox",
    inboxDescription: "Edits, approvals, archives, publish results, and history belong only to that member.",
    destinationsTitle: "Private Destinations",
    destinationsDescription: "Each member owns a separate Telegram bot credential and destination list.",
    setupTitle: "Private Curation Setup",
    setupDescription: "Every member controls separate sources, filters, AI preferences, and monitored post records.",
  },
  form: {
    title: "Add Workspace Member",
    description: "New accounts use Supabase Auth and receive a separate personal workspace.",
    email: "Email address",
    emailPlaceholder: "member@example.com",
    emailHelp: "Email becomes the durable Supabase identity used to isolate personal data.",
    password: "Temporary password",
    passwordPlaceholder: "Minimum 8 characters",
    role: "Access role",
    roles: {
      adminOption: "Admin — Personal curation & publishing",
      superAdminOption: "Super-Admin — Personal workspace + system administration",
      adminTitle: "Admin access",
      superAdminTitle: "Super-Admin access",
      adminDescription: "Gets private sources, filters, AI preferences, monitored posts, Inbox, Destinations, and publishing history.",
      superAdminDescription: "Gets a fully private curation workspace plus permission to manage team members and system health.",
    },
    submit: "Provision workspace member",
    submitting: "Provisioning member…",
  },
  feedback: {
    validEmail: "Enter a valid email address. New workspace members use Supabase Auth.",
    passwordLength: "Temporary passwords must be at least 8 characters.",
    provisionSuccess: "Workspace member “{{identity}}” was provisioned with a fully private curation and publishing workspace.",
    provisionFailed: "Unable to provision this workspace member.",
    revokeConfirm: "Revoke access for “{{identity}}”? Their sources, filters, AI preferences, monitored posts, Inbox, Destinations, and publishing history will be retained for audit/recovery, but they will no longer be able to sign in.",
    revokeSuccess: "Access for “{{identity}}” was revoked. Personal workspace data was retained.",
    revokeFailed: "Unable to revoke access. Make sure you are not revoking yourself or the final Super-Admin.",
    revokeAccountFailed: "Unable to revoke this account.",
  },
  members: {
    title: "Workspace Members",
    summary: "{{active}} active · {{total}} total",
    legacySuffix: " · {{legacy}} legacy",
    isolationEnabled: "Personal workspace isolation enabled",
    legacyTitle: "Legacy accounts still exist",
    legacyDescription: "They remain compatible and use a normalized username as their personal workspace key. New members should be created with email so ownership is tied to an immutable Supabase user ID.",
    you: "You",
    roles: {
      superAdmin: "Super-Admin",
      admin: "Admin",
    },
    status: {
      active: "Active",
      revoked: "Revoked",
    },
    added: "Added {{date}}",
    providers: {
      supabase: "Supabase Auth",
      legacy: "Legacy identity",
    },
    privateWorkspace: "Private Inbox + Destinations",
    legacyWarning: "Legacy workspace ownership is username-based. Prefer an email/Supabase account for new members.",
    revoke: "Revoke access",
    emptyTitle: "No workspace members found",
    emptyDescription: "Provision the first account from the form.",
  },
} as const;

export default team;
